module.exports = __webpack_public_path__ + "img/blue.76c6c48b.png";